import { render, staticRenderFns } from "./AgencyMenu.vue?vue&type=template&id=5b526619&scoped=true&"
import script from "./AgencyMenu.vue?vue&type=script&lang=ts&"
export * from "./AgencyMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AgencyMenu.vue?vue&type=style&index=0&id=5b526619&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b526619",
  null
  
)

export default component.exports